export const QUERY_PARAMETER_QUERY_LABEL = 'query';
export const QUERY_PARAMETER_VIEW_LABEL = 'view';
export const QUERY_PARAMETER_ONLY_ALERTS_LABEL = 'onlyAlerts';
export const BASE_URL = '/jira/ops';
